<div
  class="pl-3 pr-3 d-flex justify-content-between justify-content-sm-end gap-3 ml-sm-auto">
  <span class="c-link" (click)="backToDashBoard()">
    <i class="fa fa-chevron-left"></i>
    {{ 'selectVaccines.back_to_db' | cxTranslate }}</span
  >
  <span class="c-link" (click)="downloadExcel()">
    <i class="fa fa-icon fa-file-excel"></i>
    {{ 'selectVaccines.xls' | cxTranslate }}</span
  >
  <span class="c-link" (click)="onFluPrint()">
    <i class="fa fa-print"></i>
    {{ 'selectVaccines.print' | cxTranslate }}</span
  >
</div>
<section
  class="container influenzaCategory-Container mt-5"
  *ngIf="reservationDetails$ | async as reservationDetails">
  <section>
    <aside
      class="col-lg-4 col-md-4 col-sm-12 right-navigation float-right totals-width est-Rwd">
      <div class="mb-4 mt-4">
        @if (isPharmacyUser$ | async) {
          <!-- Order Total -->
          <section
            class="d-flex gap-1 col-md-12 py-4 d-flex align-items-center justify-content-center justify-content-md-between flex-column flex-md-row">
            <h3 class="font-bold mb-0">
              {{ 'orderConfirmation.estimatedTotal' | cxTranslate }}
            </h3>
            <span class="c-widget-title c-heading c-heading-h3 text-center">
              <h3 class="font-bold mb-0">
                {{ reservationDetails?.totalPriceWithTax?.formattedValue }}
              </h3>
            </span>
          </section>
        }
      </div>
      <section
        class="mt-3"
        *ngIf="reservationDetails$ | async as reservationDetails">
        <div
          class="col-12 mb-5"
          *ngIf="
            reservationDetails?.state === 'BUYER_DRAFT' && inEditableDateRange$
              | async
          ">
          @if (isPharmacyUser$ | async) {
            <div class="d-flex gap-1">
              <button
                class="c-button c-button--primary"
                (click)="openModal(RESERVATION_ACTIONS.APPROVE)">
                {{ 'flu.reservation-details.actions.approve' | cxTranslate }}
              </button>
              <button
                class="c-button c-button--secondary"
                (click)="openModal(RESERVATION_ACTIONS.REJECT)">
                {{ 'flu.reservation-details.actions.reject' | cxTranslate }}
              </button>
              <button
                class="c-button c-button--secondary"
                (click)="openModal(RESERVATION_ACTIONS.AKNOWLEDGE)">
                {{ 'flu.reservation-details.actions.aknowledge' | cxTranslate }}
              </button>
            </div>
            <app-terms-conditions
              class="d-block mt-3"
              compName="TandC-checkout"></app-terms-conditions>

            @if (!(isDirectUser$ | async)) {
              <app-wholesaler-pharmacy
                class="d-block mt-3"></app-wholesaler-pharmacy>
            }
          } @else {
            <div class="d-flex gap-1">
              <button
                class="c-button c-button--primary"
                (click)="editReservation(reservationDetails)">
                {{ 'flu.reservation-details.actions.edit' | cxTranslate }}
              </button>
              <button
                class="c-button c-button--secondary"
                (click)="openModal(RESERVATION_ACTIONS.CANCEL)">
                {{ 'flu.reservation-details.actions.cancel' | cxTranslate }}
              </button>
            </div>
          }
        </div>

        <app-flu-confirmation-right-content></app-flu-confirmation-right-content>
      </section>
    </aside>
    <section class="col-8 u-border-right-grey pt-3 pr-5">
      <div class="row mb-3 pb-3 u-border-bottom-grey">
        <h4 class="col-12">
          <span
            [innerHTML]="
              'flu.reservation-details.reservation-number'
                | cxTranslate: { '0': reservationDetails?.code }
            "></span>
        </h4>
        <h4 class="col-12">
          <span
            [innerHTML]="
              'flu.reservation-details.reservation-date'
                | cxTranslate
                  : {
                      '0': reservationDetails?.creationTime | date: DATE_FORMAT,
                    }
            "></span>
        </h4>
      </div>

      <!-- Order status -->
      <div class="row pt-4 pb-md-4 u-border-bottom-grey">
        <div class="col-md-4">
          <h3 class="font-bold">
            {{ 'orderDetail.orderStatus' | cxTranslate }}
          </h3>
          <p
            class="m-md-0"
            *ngIf="
              reservationDetails?.state !== undefined &&
              reservationDetails?.state !== ''
            ">
            {{
              reservationDetails?.state === 'Created'
                ? 'Confirmed'
                : reservationDetails?.state
            }}
          </p>
          <p
            class="m-md-0"
            *ngIf="
              reservationDetails?.statusDisplay === undefined ||
              reservationDetails?.statusDisplay === ''
            "></p>
        </div>
        <div class="col-md-4">
          <h3 class="font-bold">{{ 'orderDetail.placedBy' | cxTranslate }}</h3>
          <p
            class="m-md-0"
            *ngIf="
              reservationDetails?.placedBy !== undefined &&
              reservationDetails?.placedBy !== ''
            ">
            {{ reservationDetails?.placedBy }}
          </p>
          <p
            class="m-md-0"
            *ngIf="
              (reservationDetails?.placedBy === undefined ||
                reservationDetails?.placedBy === '') &&
              reservationDetails?.user?.name !== undefined &&
              reservationDetails?.user?.name !== ''
            ">
            {{ reservationDetails?.user?.name }}
          </p>
          <p
            class="m-md-0"
            *ngIf="
              (reservationDetails?.placedBy === undefined ||
                reservationDetails?.placedBy === '') &&
              (reservationDetails?.user?.name === undefined ||
                reservationDetails?.user?.name === '')
            ">
            -
          </p>
        </div>
        <div class="col-md-4">
          <h3 class="font-bold">
            {{ 'orderDetail.po' | cxTranslate }}
          </h3>
          <p
            class="m-md-0"
            *ngIf="
              reservationDetails?.purchaseOrderNumber !== undefined &&
              reservationDetails?.purchaseOrderNumber !== ''
            ">
            {{ reservationDetails?.purchaseOrderNumber }}
          </p>
          <p
            class="m-md-0"
            *ngIf="
              reservationDetails?.purchaseOrderNumber === undefined ||
              reservationDetails?.purchaseOrderNumber === ''
            ">
            -
          </p>
        </div>
      </div>

      <!-- Order price breakdown -->
      @if (isPharmacyUser$ | async) {
        <div class="col-md-5 mt-4">
          <div class="row mb-2">
            <div class="">
              {{ 'orderDetail.orderSubtotal' | cxTranslate }}
            </div>
            <div class="col-6 text-right">
              {{ reservationDetails?.subTotal?.formattedValue }}
            </div>
          </div>
          <div class="row pb-2" *ngIf="reservationDetails?.deliveryCost?.value">
            <div class="">
              {{ 'addToCartItems.delivery' | cxTranslate }}
            </div>
            <div class="col-6 text-right">
              {{ reservationDetails?.deliveryCost?.value | localCurrency }}
            </div>
          </div>
          <div class="row pb-2" *ngIf="">
            <div class="">
              {{ 'orderDetail.salesTax' | cxTranslate }}
            </div>
            <div class="col-6 text-right">
              {{ reservationDetails?.totalTax?.formattedValue }}
            </div>
          </div>
          <div class="row mt-2 pt-2 font-bold u-border-top-grey">
            <div class="">
              {{ 'orderDetail.orderTotals' | cxTranslate }}
            </div>
            <div class="col-6 text-right">
              {{ reservationDetails?.totalPrice?.formattedValue }}
            </div>
          </div>
        </div>

        <div class="row u-border-bottom-grey my-4"></div>
      }

      <!-- Products list -->
      <section
        class="row py-4 mt-2 mt-md-0"
        *ngFor="let productEntry of reservationDetails.entries">
        <!-- image -->
        <div class="col-md-2 mb-4">
          <a
            class="in-active"
            (click)="openProductDetails(productEntry)"
            title="{{ productEntry?.product?.name }}">
            <cx-media
              *ngIf="productEntry.product.images"
              [container]="productEntry.product.images"
              format="thumbnail"></cx-media>
            <img
              *ngIf="!productEntry.product.images"
              class="prod-Image"
              [src]="fallbackImage"
              alt="Product Image" />
          </a>
        </div>
        <!-- details -->
        <div class="col-md-10">
          <a
            class="c-link mb-1 black-link"
            title="{{ productEntry?.product?.name }}"
            (click)="openProductDetails(productEntry)">
            <span [innerHTML]="productEntry?.product?.name"></span>
          </a>
          <p class="mb-1" [innerHtml]="productEntry?.product?.description"></p>
          <div class="d-md-flex justify-content-between text-fixed-medium">
            <div>
              <span class="font-bold">{{
                'orderDetail.quantity' | cxTranslate
              }}</span>
              <span class="mr-1">{{ productEntry?.quantity }}</span>
              @if (productEntry?.product?.quantityPerUnit) {
                <span>{{
                  'flu.checkout.doses-in-pack'
                    | cxTranslate
                      : {
                          doses:
                            productEntry?.product?.quantityPerUnit *
                            productEntry?.quantity,
                        }
                }}</span>
              }
            </div>
            <div *ngIf="selectedChannel == 'PUBLIC'">
              <span class="font-bold">
                {{ 'addToCartItems.availableQuantity' | cxTranslate }}
              </span>
              <span class="d-inline-block d-sm-none"
                >:&nbsp;
                {{ productEntry?.remainingQuantity }}
              </span>
              <span class="d-none d-md-block">{{
                productEntry?.remainingQuantity
              }}</span>
            </div>
            <ng-container *ngIf="stdCartType || (isPharmacyUser$ | async)">
              <div>
                <span class="font-bold">{{
                  'plp.yourPrice' | cxTranslate
                }}</span>
                <span class="d-inline-block d-sm-none"
                  >:&nbsp;{{ productEntry?.basePrice?.formattedValue }}</span
                >
                <span class="d-none d-md-block">{{
                  productEntry?.basePrice?.formattedValue
                }}</span>
              </div>
              <div>
                <span class="font-bold">{{
                  'addToCartItems.subtotal' | cxTranslate
                }}</span>
                <span class="d-inline-block d-sm-none"
                  >:&nbsp;{{ productEntry?.totalPrice?.formattedValue }}</span
                >
                <span class="d-none d-md-block">{{
                  productEntry?.totalPrice?.formattedValue
                }}</span>
              </div>
            </ng-container>
          </div>
          <p class="mb-1">
            <span class="font-bold">
              {{ 'orderDetail.productNumber' | cxTranslate }}</span
            >
            {{ productEntry?.product?.code }}
          </p>
        </div>
      </section>
    </section>

    <!-- ==================RIGHT Section=================================== -->
  </section>
</section>

<ng-template #actionModal>
  <div class="p-5" *ngIf="reservationDetails$ | async as reservationDetails">
    <h2 class="mb-3">
      <strong>
        {{
          'flu.reservation-details.' + reservationSelectedAction + '.title'
            | cxTranslate
        }}
      </strong>
      <span class="close-icon c-icon-primary" (click)="dismiss()">&times;</span>
    </h2>

    <p>
      {{
        'flu.reservation-details.' + reservationSelectedAction + '.message'
          | cxTranslate
      }}
    </p>
    @if (reservationSelectedAction === RESERVATION_ACTIONS.APPROVE) {
      <h3 class="font-bold u-border-top-grey pt-3">
        {{ 'orderConfirmation.orderSubTotal' | cxTranslate }}
        {{ reservationDetails?.totalPrice?.formattedValue }}
      </h3>
      <p>
        {{
          'flu.reservation-details.' +
            reservationSelectedAction +
            '.info-message' | cxTranslate
        }}
      </p>
      <div class="u-border-top-grey pt-3" *ngIf="!(isDirectUser$ | async)">
        <app-wholesaler-pharmacy [editable]="false"></app-wholesaler-pharmacy>
      </div>
      <h3 class="font-bold mt-5 u-border-top-grey pt-3">
        {{ 'flu.reservation-details.ship-to' | cxTranslate }}
      </h3>
      <p class="m-0">
        {{
          reservationDetails?.associatedUnit?.shippingAddresses[0]
            ?.formattedAddress
        }}
        ({{ reservationDetails?.associatedUnit?.shippingAddresses[0]?.unitID }})
      </p>
      <h3 class="font-bold mt-5 u-border-top-grey pt-3">
        {{ 'flu.reservation-details.order-contact' | cxTranslate }}
      </h3>
      <p class="m-0">
        {{ reservationDetails?.user?.name }}
      </p>
      <p class="m-0">
        {{ reservationDetails?.user?.email }}
      </p>
      <p class="m-0">
        {{ reservationDetails?.user?.phoneNumber }}
      </p>
      <app-terms-conditions
        class="d-block mt-3"
        compName="TandC-checkout"></app-terms-conditions>
    }

    <div class="d-flex gap-1 mt-5 justify-content-center">
      <button
        class="c-button c-button--primary"
        (click)="dismiss(reservationDetails)">
        {{
          'flu.reservation-details.' + reservationSelectedAction + '.confirm'
            | cxTranslate
        }}
      </button>
      <button class="c-button c-button--secondary" (click)="dismiss()">
        {{
          'flu.reservation-details.' + reservationSelectedAction + '.cancel'
            | cxTranslate
        }}
      </button>
    </div>
  </div>
</ng-template>
